// FAQ Accordion Functionality
function toggleFaq(index) {
    const faqItem = document.querySelector(`[data-faq-index="${index}"]`);
    const faqAnswer = faqItem.querySelector('.faq-answer');
    const isActive = faqItem.classList.contains('active');
    
    // Close all other FAQ items
    document.querySelectorAll('.faq-item').forEach(item => {
        if (item !== faqItem) {
            item.classList.remove('active');
            item.querySelector('.faq-answer').classList.remove('active');
        }
    });
    
    // Toggle current item
    if (isActive) {
        faqItem.classList.remove('active');
        faqAnswer.classList.remove('active');
    } else {
        faqItem.classList.add('active');
        faqAnswer.classList.add('active');
    }
}

// Initialize FAQ on DOM load
document.addEventListener('DOMContentLoaded', function() {
    // Add click event listeners to all FAQ questions
    document.querySelectorAll('.faq-question').forEach((question, index) => {
        question.addEventListener('click', () => toggleFaq(index));
        
        // Add keyboard accessibility
        question.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleFaq(index);
            }
        });
        
        // Make focusable for accessibility
        question.setAttribute('tabindex', '0');
        question.setAttribute('role', 'button');
        question.setAttribute('aria-expanded', 'false');
    });
});